import { observeElement, getWidget } from '@uvocore-front/utils';
import { isTablet } from '../../utils';
import Carousel from '../CustomCarousel';

if (document.querySelector('[data-testimonials-list]')) {
  const monthNames = [
    'Jan', 'Feb', 'Mar',
    'Apr', 'May', 'Jun', 'Jul',
    'Aug', 'Sep', 'Oct',
    'Nov', 'Dec',
  ];

  const template = (testimonialItem) => {
    let date = new Date(testimonialItem.createdAt * 1000);
    date = `${date.getDate()} ${monthNames[date.getMonth()]} ${date.getFullYear()}`;

    return (
      `<div class="Testimonial" data-testimonials-item>
        <div class="Testimonial__preview">
          <div class="Testimonial__title">customer's feedback (<span>${testimonialItem.customerId}</span>)</div>
          <div class="Testimonial__text">
            "${testimonialItem.body}"
          </div>
          <div class="Testimonial__dots"><span></span><span></span><span></span></div>
        </div>
        <div class="Testimonial__info">
          <div class="Testimonial__info__content">
            <div class="Testimonial__info__discipline">
              Discipline: <span>${testimonialItem.orderDiscipline}</span>
            </div>
            <div class="Testimonial__info__body">
              <div class="Testimonial__title">customer's feedback (<span>${testimonialItem.customerId}</span>)</div>
              <div class="Testimonial__text">
                "${testimonialItem.body}"
              </div>
              <div class="Testimonial__date">${date}</div>
            </div>
          </div>
          <div class="Testimonial__icons"><span></span><span></span><span></span></div>
        </div>
      </div>`
    );
  };

  observeElement({ /* eslint-disable-line */
    element: '[data-testimonials-list]',
    marginValue: 200,
    callback: () => {
      getWidget({ /* eslint-disable-line */
        widgetLink: '/assets/js/testimonialsWidget.min.js',
        loader: false,
        fn: () => {
          window.tmWidget({
            params: {
              siteId: '15',
              limit: 6,
              minBodyLength: 0,
            },
            template,
            type: 'html',
            containerEl: '[data-testimonials-list]',
            callbackLoaded: () => {
              // eslint-disable-next-line no-new
              new Carousel({
                selector: document.querySelector('[data-testimonials-list]'),
                itemWidth: 255,
                margin: 0,
                responsive: {
                  768: {
                    inactive: true,
                  },
                },
              });

              if (!isTablet()) {
                const samples = document.querySelectorAll('[data-testimonials-item]');
                setTimeout(() => {
                  samples[1].classList.add('is--active');
                }, 500);

                [].slice.call(samples).forEach((sample) => {
                  sample.addEventListener('mouseenter', () => {
                    if (document.querySelector('.Testimonial.is--active')) {
                      document.querySelector('.Testimonial.is--active').classList.remove('is--active');
                      sample.classList.add('is--active');
                    }
                  });
                });
              }
            },
          });
        },
      });
    },
  });
}
